// extracted by css-extract-rspack-plugin
export default {"viewAllWrapper":"_5ca59b86","viewAllCta":"_efe8adc3"};